// extracted by mini-css-extract-plugin
module.exports = {"SettingsButton":"style_SettingsButton__NuOlk"};